export default __webpack_public_path__ + "static/32-ef87ba25329a14f443c6f67d56eadbfe.jpg";